import { render, staticRenderFns } from "./alla-ovningar.vue?vue&type=template&id=a612e5fa&scoped=true"
import script from "./alla-ovningar.vue?vue&type=script&lang=js"
export * from "./alla-ovningar.vue?vue&type=script&lang=js"
import style0 from "./alla-ovningar.vue?vue&type=style&index=0&id=a612e5fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a612e5fa",
  null
  
)

export default component.exports